// ImportedFilesTable.tsx
import React, { Component, Fragment } from "react";
import { Toast } from "primereact/toast";
import moment from "moment";
import { Column } from "primereact/column";
import history from "../../../history";
import { ImportedFiles } from "../../../models/IssuingClientsModel";
import { PagedResult } from "../../../models/Result";
import { SearchRequestBaseModel, SortOrderType } from "../../../models/SearchRequestModel";
import ExtendedDataTable from "../../../components/ExtendedDataTable";
import DataTableToolbar from "../../../components/ui/DataTableToolbar";
import { utils } from "../../../utils/utils";
import { dateFilterTemplate, numberFilterMatchModeOptions } from "../../Paginator";

interface Props {
    loadApi: (searchRequest: SearchRequestBaseModel) => Promise<PagedResult<ImportedFiles[]>>;
    detailsRoute: string;
    from?: string;
    to?: string;
}

interface State {
    files: ImportedFiles[];
    isLoading: boolean;
    totalRecords: number;
}

export default class ImportedFilesTable extends Component<Props, State> {
    private toast: Toast | null = null;
    private dataTable: ExtendedDataTable | null = null;

    constructor(props: Props) {
        super(props);
        this.state = { files: [], isLoading: false, totalRecords: 0 };
    }
    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.from !== this.props.from ||
            prevProps.to !== this.props.to
        ) {
            // Reset table to first page and reload
            this.dataTable?.reset();
        }
    }

    loadFilesData = async (searchRequest: SearchRequestBaseModel) => {
        this.setState({ isLoading: true });
        searchRequest.filters = utils.manageDataTableFilters(searchRequest.filters);

        const result = await this.props.loadApi({ ...searchRequest, from: this.props.from, to: this.props.to });

        if (!result.success) {
            this.toast?.show({ severity: "error", summary: "Error", detail: result.message, life: 3000 });
        }

        this.setState({ files: result.data, totalRecords: result.totalCount, isLoading: false });
    };

    onFileDetailsClick = (file: ImportedFiles) => {
        history.push(`${this.props.detailsRoute}/${file.id}`);
    };
    renderHeader = (hasActiveFilters: boolean) => (
        <DataTableToolbar onClear={() => this.dataTable!.reset()} showAdd={false} hasActiveFilters={hasActiveFilters} />
    );

    render() {
        return (
            <Fragment>
                <div>
                    <Toast ref={(el) => (this.toast = el)} />
                    <ExtendedDataTable
                        header={this.renderHeader}

                        ref={(ref) => (this.dataTable = ref)}
                        value={this.state.files}
                        onChange={this.loadFilesData}
                        loading={this.state.isLoading}
                        totalRecords={this.state.totalRecords}
                        defaultSortField=""
                        defaultSortOrder={SortOrderType.Descending}
                        onRowClick={(e: { data: ImportedFiles }) => this.onFileDetailsClick(e.data)}
                    >
                        <Column {...({ alwaysVisible: true } as any)} field="id" header="File ID" />
                        <Column {...({ alwaysVisible: true } as any)} field="fileName" header="File Name"
                            body={(rowData: ImportedFiles) => (
                                <span
                                    style={{ color: "#0d6efd", cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => this.onFileDetailsClick(rowData)}
                                >
                                    {rowData.fileName}
                                </span>
                            )}


                        />
                        <Column
                            field="importDt"
                            header="Imported Date"
                            filterMatchModeOptions={numberFilterMatchModeOptions}
                            dataType="date"
                            filterElement={dateFilterTemplate}
                            body={(rowData) => moment.utc(rowData.importDt).local().format("DD/MM/YYYY HH:mm:ss")}
                        />
                    </ExtendedDataTable>

                </div>
            </Fragment>
        );
    }
}
